import { API_LAVORIS_URL, V1 } from "../constants/axios/AxiosConstants";
import AxiosService from "./axios/AxiosService";
import AuthService from "./auth/AuthServices";
import UserService from "./user/UserServices";
import CompanyServices from "./Company/CompanyServices";
import PublicDataService from "./publicData/PublicData";
import ParticularPatientService from "./ParticularPatient/ParticularPatient";
import TurnServices from "./TurnServices/TurnServices";
import LegalServices from "./Legal/LegalServices";
import AbsencesServices from "./Absences/AbsenceServices";
import DangerZonesServices from "./DangerZones/DangerZonesServices";
import FilesServices from "./Files/FilesServices";
import ExamsMoldesService from "./Exams-Moldes";
import CommonService from "./Common/Common";
import Validation from "./Validation";
import RemoteGoogleLink from "./RemoteGoogleLink/RemoteGoogleLink";
import LocationsArgentina from "./LocationsArgentina";
import Notification from "./Notifications";
import FilesService from "./Files/FilesServices";
import AreaCodesService from "./AreaCodes/AreaCodes";
import RolesService from "./Roles/RolesService";

export default class LavorisService extends AxiosService {
  private static instance: LavorisService;

  //Authentication Services
  public Auth: AuthService = new AuthService(this.axios);

  //User Services
  public User: UserService = new UserService(this.axios);

  //Public Data Services
  public PublicData: PublicDataService = new PublicDataService(this.axios);

  //Company Services
  public CompanyServices: CompanyServices = new CompanyServices(this.axios);

  //Area Codes Services
  public AreaCodesService: AreaCodesService = new AreaCodesService(this.axios);

  //ParticularPatient Services
  public ParticularPatient: ParticularPatientService =
    new ParticularPatientService(this.axios);

  //Turns Services
  public TurnServices: TurnServices = new TurnServices(this.axios);

  //Absences Services
  public AbsencesServices: AbsencesServices = new AbsencesServices(this.axios);

  //Legal Services
  public LegalServices: LegalServices = new LegalServices(this.axios);

  //Absences Services
  public Absences: AbsencesServices = new AbsencesServices(this.axios);

  //Danger Zones Services
  public DangerZones: DangerZonesServices = new DangerZonesServices(this.axios);

  //Files Services
  public Files: FilesServices = new FilesServices(this.axios);

  public ExamsMoldes = new ExamsMoldesService(this.axios);

  //Remote google link
  public RemoteGoogleLink: RemoteGoogleLink = new RemoteGoogleLink(this.axios)

  //Common services
  public Common = new CommonService(this.axios);

  //Validation services
  public ValidationService: Validation = new Validation(this.axios);

  //Roles service
  public RolService: RolesService = new RolesService(this.axios);


  //Locations of Argentina
  public LocationsArgentinaService: LocationsArgentina = new LocationsArgentina(this.axios)

  public NotificationsService: Notification = new Notification(this.axios)

  public FilesService: FilesService = new FilesService(this.axios);


  constructor() {
    super(API_LAVORIS_URL, V1);
  }

  public static getInstance(): LavorisService {
    if (!LavorisService.instance) {
      LavorisService.instance = new LavorisService();
    }

    return LavorisService.instance;
  }
}
